// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"001c1e2e","122":"a9b75a66","493":"4d93c574","531":"49eed97e","805":"09930dbe","955":"ebf88b16"}[chunkId] + ".chunk.js";
};